import React from 'react';

const MONTHS = ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'];
const fmt = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const monthRange = (y, m) => [fmt(new Date(y, m, 1)), fmt(new Date(y, m + 1, 0))];

const presets = () => {
  const now = new Date();
  const y = now.getFullYear();
  const m = now.getMonth();
  return [
    { key: 'this-month', label: 'החודש', range: monthRange(y, m) },
    { key: 'last-month', label: 'חודש קודם', range: monthRange(m === 0 ? y - 1 : y, m === 0 ? 11 : m - 1) },
    { key: 'last-3-months', label: '3 חודשים אחרונים', range: [fmt(new Date(y, m - 2, 1)), fmt(new Date(y, m + 1, 0))] },
    { key: 'this-year', label: 'השנה', range: [`${y}-01-01`, `${y}-12-31`] },
  ];
};

export const DateRangePresets = ({ startDate, endDate, onChange }) => {
  const year = new Date().getFullYear();
  const years = Array.from({ length: 6 }, (_, i) => year - i);
  const [selYear, selMonth] = (() => {
    const s = startDate && startDate.split('-');
    if (s && monthRange(+s[0], +s[1] - 1).join() === [startDate, endDate].join()) return [s[0], String(+s[1] - 1)];
    return ['', ''];
  })();
  const pickMonth = (y, m) => { if (y !== '' && m !== '') onChange(...monthRange(+y, +m)); };
  const selectCls = 'p-2 text-base border-2 rounded-md bg-white hover:border-blue-400 transition-colors';

  return (
    <div className="flex flex-wrap items-center gap-2 mb-5" data-testid="date-presets">
      {presets().map((p) => {
        const active = p.range[0] === startDate && p.range[1] === endDate;
        return (
          <button
            key={p.key}
            type="button"
            onClick={() => onChange(...p.range)}
            className={`px-4 py-2 rounded-full text-sm font-semibold border-2 transition-colors ${active ? 'bg-blue-600 text-white border-blue-600' : 'bg-white text-blue-700 border-blue-200 hover:bg-blue-50 hover:border-blue-400'}`}
            data-testid={`date-preset-${p.key}`}
          >
            {p.label}
          </button>
        );
      })}
      <span className="text-gray-400 mx-1">|</span>
      <select value={selMonth} onChange={(e) => pickMonth(selYear || String(year), e.target.value)} className={selectCls} data-testid="date-month-select">
        <option value="">בחר חודש</option>
        {MONTHS.map((name, i) => <option key={name} value={String(i)}>{name}</option>)}
      </select>
      <select value={selYear} onChange={(e) => pickMonth(e.target.value, selMonth || String(new Date().getMonth()))} className={selectCls} data-testid="date-year-select">
        <option value="">שנה</option>
        {years.map((y) => <option key={y} value={String(y)}>{y}</option>)}
      </select>
    </div>
  );
};
